<template>
    <RedesignBaseModal
        data-testid="dialog-delete"
        :visible="visible"
        :top="'8vh'"
        :append-to-body="appendToBody"
        width="520px"
        wrapper-classes="full-height reorder-groups-modal"
        @update:visible="onChangeVisible"
        @close="closeModal"
    >
        <template #title>
            <div class="text-xl px-2" data-testid="dialog-title">
                {{ modalTitle }}
            </div>
        </template>
        <div class="my-5 flex flex-col items-center justify-center" data-testid="dialog-message">
            <component
                :is="descriptionIcon"
                class="mb-5"
            />
            <div class="text-center main-text-color text-base max-w-65-p break-normal">
                {{ description }}
            </div>
        </div>
        <template #footer>
            <div class="w-full flex items-center justify-between" data-testid="dialog-actions">
                <RedesignBaseButton
                    data-testid="dialog-button-cancel"
                    type="outline"
                    color="secondary"
                    icon="IconDiscard"
                    @click="closeModal"
                >
                    {{ $t('common.cancel') }}
                </RedesignBaseButton>
                <RedesignBaseButton
                    data-testid="dialog-button-confirm"
                    :loading="loading"
                    icon="IconConfirm"
                    @click="confirm"
                >
                    {{ $t('common.delete') }}
                </RedesignBaseButton>
            </div>
        </template>
    </RedesignBaseModal>
</template>

<script setup lang="ts">
import RedesignBaseModal from '@/components/RedesignComponents/Modal/RedesignBaseModal.vue'
import { computed } from 'vue'
import i18n from '@/i18n'
import RedesignBaseButton from '@/components/RedesignBaseComponents/Buttons/RedesignBaseButton.vue'

const props = withDefaults(
    defineProps<{
        visible?: boolean
        loading?: boolean
        title?: string
        description?: string
        modalWidth?: string
        descriptionIcon?: string
        appendToBody?: boolean
    }>(), {
        visible: false,
        title: '',
        description: undefined,
        descriptionIcon: undefined,
        modalWidth: '445px',
        appendToBody: true
    }
)
const emit = defineEmits<{
    (e: 'on-cancel',): void
    (e: 'on-confirm'): void,
    (e: 'update:visible', value: boolean): void
}>()


const modalTitle = computed(() => {
    return props.title || i18n.t('general.deleteConfirmation')
})

function onChangeVisible (value: boolean) {
    emit('update:visible', value)
}

function closeModal () {
    emit('on-cancel')
}

function confirm () {
    emit('on-confirm')
}
</script>
